import React, { useEffect, useRef, useState } from 'react';
import Masonry from 'react-masonry-css';
import img1 from '../assets/img/gallery/1.png';
import img2 from '../assets/img/gallery/2.png';
import img3 from '../assets/img/gallery/3.png';
import img4 from '../assets/img/gallery/4.png';
import img5 from '../assets/img/gallery/5.png';
import img6 from '../assets/img/gallery/6.png';
import img7 from '../assets/img/gallery/7.png';
import './Gallery.css';

const Gallery = () => {
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: img1 },
    { id: 2, src: img2 },
    { id: 3, src: img3 },
    { id: 4, src: img4 },
    { id: 5, src: img5 },
    { id: 6, src: img6 },
    { id: 7, src: img7 }
  ];

  const breakpointColumns = {
    default: 3,
    1100: 2,
    700: 1,
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    if (descRef.current) {
      const items = descRef.current.children;
      for (const item of Array.from(items)) {
        if (item) {
          observer.observe(item);
        }
      }
    }

    return () => observer.disconnect();
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="gallery" data-section="gallery">
      <div className="gallery__inner">
        <h2 className="gallery__title" ref={titleRef}>
          Gallery
        </h2>
        <div className="gallery__desc" ref={descRef}>
          <Masonry
            breakpointCols={breakpointColumns}
            className="gallery__masonry"
            columnClassName="gallery__masonry-column"
          >
            {images.map((image) => (
              <div
                key={image.id}
                className="gallery__item"
                onClick={() => handleImageClick(image)}
              >
                <div className="gallery__item-inner">
                  <img src={image.src} alt={`Gallery ${image.id}`} />
                </div>
              </div>
            ))}
          </Masonry>
        </div>
      </div>

      {selectedImage && (
        <div className="gallery__modal" onClick={handleCloseModal}>
          <div className="gallery__modal-content">
            <img
              src={selectedImage.src}
              alt={`Gallery ${selectedImage.id}`}
            />
            <button className="gallery__modal-close" onClick={handleCloseModal}>
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
